// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"510":"aa2d0a41","645":"ca1ef65b","649":"93e96b8a"}[chunkId] + ".chunk.js";
};